import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TBookmark = components['schemas']['BookmarkResDto'];
export type TTestSamplePicker = components['schemas']['TestSamplePickerResDto'];
export type TTestSampleBookmark = components['schemas']['TestSamplePickerBookmarkDto'];
export type TTestSampleRequest = components['schemas']['TestSamplePickerRequestDto'];

export const BOOKMARKS_PAGE = 100;

export const listBookmarks = (cursor?: string) =>
  unwrap(api.GET('/v1/bookmarks', { params: { query: { cursor, limit: BOOKMARKS_PAGE } } }));

export const removeBookmark = async (id: string): Promise<void> => {
  await unwrap(api.DELETE('/v1/bookmarks/{id}', { params: { path: { id } } }));
};

/**
 * The flow's default test sample; `null` clears it. Refused (400) unless the bookmarked
 * request came in on the source the flow starts from.
 */
export const setDefaultBookmark = async (flowId: string, bookmarkId: string | null) => {
  await unwrap(
    api.POST('/v1/flows/{id}/default-bookmark', {
      params: { path: { id: flowId } },
      body: { bookmarkId },
    }),
  );
};

type TPickerQuery = { before?: string; requestId?: string };
export const getTestSamplePicker = (id: string, query: TPickerQuery = {}) =>
  unwrap(api.GET('/v1/flows/{id}/draft/test-samples-picker', { params: { path: { id }, query } }));

export const bookmarkKeys = {
  all: ['bookmarks'] as const,
  list: ['bookmarks', 'list'] as const,
  /** Under the flow's key, so anything that refreshes the flow refreshes its samples. */
  picker: (flowId: string) => ['flows', flowId, 'draft', 'test-samples-picker'] as const,
};
